import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import Paginator from 'components/paginator';
import SortableColumns from 'components/hoc/sortable_columns';
import { AiServiceStore } from '@seedlang/stores';
import cx from 'classnames';
import InPlaceText from 'components/form/in_place_text';
import AiServiceCreate from './ai_service_create';
import DeleteButton from 'components/button/delete_button';
import autobind from 'autobind-decorator';
const Wrapper = styled.div`

`;
@observer
class AiServiceIndex extends React.Component {
  componentDidMount() {
    AiServiceStore.getIndex();
  }

  @autobind onDelete(id) {
    AiServiceStore.destroy({ ids: { aiServiceId: id } });
  }

  render() {
    return (
      <Wrapper>
        <AiServiceCreate
          clientOptions={['anthropic', 'cohere', 'deepseek', 'google', 'mistral', 'open_ai', 'qwen', 'x_ai']}
        />
        <table className='table-wrapper admin-table'>
          <thead>
            <tr>
              <th
                className={cx('sortable', this.props.columnClassNames('client'))}
                onClick={() => this.props.onSortColumn('client')}
              >
                Client
              </th>
              <th
                className={cx('sortable', this.props.columnClassNames('model'))}
                onClick={() => this.props.onSortColumn('model')}
              >
                Model
              </th>
              <th
                className={cx('sortable', this.props.columnClassNames('openRouterModelName'))}
                onClick={() => this.props.onSortColumn('openRouterModelName')}
              >
                Open Router
              </th>
              <th
                className={cx('sortable', this.props.columnClassNames('slug'))}
                onClick={() => this.props.onSortColumn('slug')}
              >
                Slug
              </th>
              <th
                className={cx('sortable', this.props.columnClassNames('translation_order'))}
                onClick={() => this.props.onSortColumn('translation_order')}
              >
                Order
              </th>
              <th
                className={cx('sortable', this.props.columnClassNames('translation_count'))}
                onClick={() => this.props.onSortColumn('translation_count')}
              >
                # Transl
              </th>
              <th
                className={cx('sortable', this.props.columnClassNames('flag_count'))}
                onClick={() => this.props.onSortColumn('flag_count')}
              >
                # Flagged
              </th>
              <th>Cost (M)</th>
              <th width='40'></th>
            </tr>
          </thead>
          <tbody>
            {
              AiServiceStore.indexData.map(item => {
                return (
                  <tr
                    key={item.id}
                  >
                    <td>{item.client}</td>
                    <td>
                      <InPlaceText
                        allowUpdate
                        submitOnEnter
                        defaultValue={item.model}
                        model='ai_services'
                        field='model'
                        id={item.id}
                      />
                    </td>
                    <td>
                      <InPlaceText
                        allowUpdate
                        submitOnEnter
                        defaultValue={item.openRouterModelName}
                        model='ai_services'
                        field='open_router_model_name'
                        id={item.id}
                      />
                    </td>
                    <td>
                      <InPlaceText
                        allowUpdate
                        submitOnEnter
                        defaultValue={item.slug}
                        model='ai_services'
                        field='slug'
                        id={item.id}
                      />
                    </td>
                    <td>
                      <InPlaceText
                        number
                        allowUpdate
                        submitOnEnter
                        defaultValue={item.translationOrder}
                        model='ai_services'
                        field='translation_order'
                        id={item.id}
                      />
                    </td>
                    <td>{item.translationCount}</td>
                    <td>
                      {item.flagCount}
                      {item.translationCount > 0 ? (
                        <> ({((item.flagCount / item.translationCount) * 100).toFixed(1)}%)</>
                      ) : (
                        <> (0%)</>
                      )}
                    </td>
                    <td>
                      {item.inputTokenCostPerMillion && item.outputTokenCostPerMillion ? (
                        `$${item.inputTokenCostPerMillion}/$${item.outputTokenCostPerMillion}`
                      ) : (
                        '-'
                      )}
                    </td>
                    <td>
                      <DeleteButton
                        onConfirm={() => this.onDelete(item.id)}
                        message='Delete this AI service?'
                        className='fa-block right'
                      />
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
        <Paginator
          store={AiServiceStore}
        />
      </Wrapper>
    );
  }
}

export default SortableColumns(AiServiceIndex, AiServiceStore, { sortColumn: 'name', sortIsAscending: true });